import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './../pages/home/home.component'
import { ContentComponent } from './../components/content/content.component'
import { PriceComponent } from 'src/pages/price/price.component';
import { ContactComponent } from './../pages/contact/contact.component'
import { HelpComponent } from '../pages/help/help.component'
import { PorcelainComponent } from '../pages/porcelain/porcelain.component'
import { InstrumentComponent } from '../pages/instrument/instrument.component';
import { TrialComponent } from '../pages/trial/trial.component'
import { AbundanceComponent } from 'src/pages/abundance/abundance.component';
import { PersonalComponent } from 'src/pages/personal/personal.component';
import { PrivacyComponent } from 'src/pages/privacy/privacy.component';
import { ServiceTermComponent } from 'src/pages/service-term/service-term.component';
import { QtWebasmComponent } from 'src/components/qt-webasm/qt-webasm.component';
import { WechatAuthComponent } from 'src/pages/oauth/authorized/wechat/wechat.component';
import { AboutUsComponent } from 'src/pages/about-us/about-us.component';
import { ChooseUsComponent } from 'src/pages/choose-us/choose-us.component';
import { NestingComponent } from 'src/pages/abundance/nesting/nesting.component';

import { authGuard } from 'src/guard/auth/auth.guard';

const routes: Routes = [
  {
    path: "", component: HomeComponent, children: [
      { path: "", redirectTo: "home", pathMatch: "full" },
      { path: "home", component: ContentComponent },
      { path: "price", component: PriceComponent },
      { path: "contact", component: ContactComponent },
      { path: "help", component: HelpComponent },
      { path: "porcelain", component: PorcelainComponent },
      { path: "instrument", component: InstrumentComponent },
      { path: "personal", component: PersonalComponent },
      { path: "privacy", component: PrivacyComponent },
      { path: "term-services", component: ServiceTermComponent },
      { path: "about-us", component: AboutUsComponent },
      { path: "choose-us", component: ChooseUsComponent },
      { path: "web", component: QtWebasmComponent },
      { path: "abundance", component: AbundanceComponent },
      { path: "trial", component: TrialComponent },
    ]
  },
  { path: "oauth/authorized/wechat", component: WechatAuthComponent },
  { path: "nesting", component: NestingComponent, canActivate: [authGuard] },
  //路由守卫，暂时不加，不登录也可以访问基本功能，只是无法导出图片
  // { path: "abundance", canActivate: [authGuard], component: AbundanceComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'top',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
